import UniversalTextField from "../../../../GlobalComponents/UniversalTextField";

const EventNotes = ({ jobData, setHasUnsavedChanges }) => {
  return (
    <UniversalTextField
      collectionName="JobData"
      docId={jobData.id}
      fieldName="eventNotes"
      value={jobData.eventNotes || ""}
      label="Event Notes"
      multiline
      rows={4}
      setHasUnsavedChanges={setHasUnsavedChanges}
      adminOnly={true}
    />
  );
};

export default EventNotes;
